import { useState } from 'react'
import pronteerLogoFull from '@/assets/pronteer-logo-full.svg'
import { PasscodeEntry } from '@/components/passcode/PasscodeEntry'
import { verifyPasscode } from '@/lib/passcode'

interface PasscodeLockScreenProps {
  onUnlock: () => void
}

/**
 * Full-screen passcode unlock overlay — the resting lock screen when passcode
 * is the active unlock method (passcode-only lock, or "Use passcode" fallback
 * after a biometric failure/lockout).
 */
export function PasscodeLockScreen({ onUnlock }: PasscodeLockScreenProps) {
  const [error, setError] = useState<string | null>(null)
  const [attempt, setAttempt] = useState(0)
  const [verifying, setVerifying] = useState(false)

  const onComplete = async (code: string) => {
    setVerifying(true)
    try {
      if (await verifyPasscode(code)) {
        onUnlock()
        return
      }
      setError('Wrong passcode. Try again.')
      setAttempt((count) => count + 1)
    } finally {
      setVerifying(false)
    }
  }

  return (
    <div className="fixed inset-0 z-9999 flex flex-col items-center bg-surface-L0 px-6 pb-[var(--safe-bottom)] pt-[var(--safe-top)]">
      <img src={pronteerLogoFull} alt="Pronteer" className="mt-14 h-[46px] w-auto" />
      <div className="flex w-full flex-1 items-center justify-center">
        <PasscodeEntry
          key={attempt}
          title="Enter your passcode"
          error={error}
          disabled={verifying}
          onComplete={(code) => void onComplete(code)}
        />
      </div>
    </div>
  )
}
